import React, { useEffect, useState } from 'react'
import LibrarySubjectCM from './LibrarySubjectCM'
import { NavLink } from 'react-router-dom'
import axios from "../../../axios";
import { handleIcons } from '../LibraySubjectDatail/iconData';
export default function LibrarySubjectProps({ handleSubjectDetail, studentDetails, subjects }) {
    return (
        <div className='Cntainer_library_subjectProps d-flex flex-wrap  gap-3' onClick={handleSubjectDetail}>
            {
                subjects.length > 0 && subjects.map((obj) => (
                    <NavLink to={`/Library/SubjectDetails`} className='link' state={{ standard_id: obj.standardId, section_id: obj.sectionId, subject_id: obj.subjectId.id, }}>
                        <div onClick={() => { localStorage.setItem('LibSubj', obj?.subjectId?.name); localStorage.setItem('LibSubjId', obj?.subjectId?.id) }}>
                            <LibrarySubjectCM
                                subname={obj?.subjectId?.name}
                                sublogo={handleIcons(obj?.subjectId?.name)}
                                bookList={`${obj.bookInfo.length} ${obj.bookInfo.length > 1 ? "Books" : "Book"}`}
                                handleSubjectDetail={handleSubjectDetail}
                            />
                        </div>
                    </NavLink>
                ))
            }
        </div>
    )
}
